export default __webpack_public_path__ + "static/media/techblog3-fig3-2.456452c8.png";